module.exports = __webpack_public_path__ + "img/cover.961e9530.png";